import React, { useEffect, useState } from "react";
import "./global.scss";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {
  timestampToDateYearFormat,
  timestampToDateTimeFormat,
  getMapIdBasedonEnvironment,
} from "../../helper/helper";
import ridingImage from "../../assets/riding.png";
import walkingImage from "../../assets/walking.png";
import cyclingImage from "../../assets/cycling.png";
import drivingImage from "../../assets/driving.png";
import { GoogleMap, Marker, Polyline } from "@react-google-maps/api";

import decodePolyline from "decode-google-map-polyline";
import origin from "../../assets/origin.png";
import destination from "../../assets/destination.png";

function ShowActiveTransports(props) {
  const transports = props.history.location.state
    ? props.history.location.state.transportList
    : [];
  const userType = props.history.location.state
    ? props.history.location.state.userType
    : "";
  const auth = getAuth();
  let positionsData = [];
  useEffect(() => {
    if (!props.history.location.state) {
      props.history.replace("/home/dashboard");
    }

    onAuthStateChanged(auth, (user) => {
      if (!user) {
        props.history.replace("/login");
      }
    });
    for (const trip of transports) {
      positionsData.push(
        {
          lat: trip.origin_geopoint._latitude,
          lng: trip.origin_geopoint._longitude,
          icon: origin,
          zIndex: 9,
        },
        {
          lat: trip.destination_geopoint._latitude,
          lng: trip.destination_geopoint._longitude,
          icon: destination,
          zIndex: 9,
        }
      );
    }
    setPositions(positionsData);
  }, []);

  const [positions, setPositions] = useState([]);
  const [map, setMap] = useState(null);
  const onLoadBounds = (map) => {
    if (!map) {
      return;
    }
    const bounds = new window.google.maps.LatLngBounds();
    positions.forEach((child) => {
      bounds.extend(new window.google.maps.LatLng(child.lat, child.lng));
    });
    map.fitBounds(bounds);
    setMap(map);
  };

  const defaultMapOptions = {
    fullscreenControl: true,
  };

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const containerStyle = {
    width: "100%",
    height: "50vh",
  };

  const options = {
    fillColor: "lightblue",
    fillOpacity: 1,
    strokeColor: "blue",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1,
  };

  const handleTransportDate = (time) => {
    return timestampToDateYearFormat(time._seconds, time._nanoseconds);
  };
  const handleTransportTime = (time) => {
    return timestampToDateTimeFormat(time._seconds, time._nanoseconds);
  };
  const handleBearerType = (bearer) => {
    switch (bearer) {
      case "driving":
        return (
          <div className="bearer">
            <img src={drivingImage} alt="rider" />
          </div>
        );
      case "riding":
        return (
          <div className="bearer">
            <img src={ridingImage} alt="rider" />
          </div>
        );
      case "cycling":
        return (
          <div className="bearer">
            <img src={cyclingImage} alt="cycle" />
          </div>
        );
      case "walking":
        return (
          <div className="bearer">
            <img src={walkingImage} alt="walk" />
          </div>
        );

      default:
        break;
    }
  };

  const loadGoogleMap = () => {
    return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        zoom={13}
        onLoad={onLoadBounds}
        onUnmount={onUnmount}
        defaultOptions={defaultMapOptions}
        options={{
          mapId: getMapIdBasedonEnvironment(),
        }}
      >
        {positions.map((marker) => (
          <Marker
            position={marker}
            key={marker.lat + marker.lng + Math.random()}
            icon={{
              url: marker.icon,
            }}
          />
        ))}
        {transports.map((trip, idx) => (
          <Polyline
            key={`polyline-${idx}`}
            path={decodePolyline(trip.overview_polyline)}
            options={options}
          />
        ))}
        <></>
      </GoogleMap>
    );
  };

  return (
    <div className="show-all-list">
      <div className="headline">
        <h3>Show Active Transports</h3>
      </div>
      {positions.length > 0 && (
        <div className="map" style={{ marginBottom: 20 }}>
          {" "}
          {loadGoogleMap()}
        </div>
      )}
      <div
        style={{
          textAlign: "left",
          marginBottom: 10,
        }}
      >
        Total transport: {transports.length}
      </div>

      <table className="table">
        <thead>
          <tr>
            <th>Transport Date</th>
            <th>Rider’s Name</th>
            <th>
              {userType && userType === "customer"
                ? "Original Price"
                : "Original Payable"}
            </th>
            <th>
              {userType && userType === "customer"
                ? "Paid Amount"
                : "Final Paid"}
            </th>
            <th>Mode of Transport</th>
            <th>Transport State</th>
            <th>Destination Address</th>
            <th>Distance</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {transports.map((transport) => (
            <tr key={transport.transport_id}>
              <td>
                {handleTransportDate(transport.time)}
                <br />
                {handleTransportTime(transport.time)}
              </td>
              <td>
                {transport.rider_given_name + " " + transport.rider_last_name}
              </td>
              <td>
                {userType && userType === "customer"
                  ? `A$ ${transport.transport_original_price}`
                  : `A$ ${transport.original_payable_to_rider}`}
              </td>
              <td>
                {userType && userType === "customer"
                  ? `A$ ${transport.transport_receivable_price}`
                  : `A$ ${transport.final_paid_to_rider}`}
              </td>
              <td>{handleBearerType(transport.assigned_bearer_type)}</td>
              <td>
                {transport.transport_state
                  ? transport.transport_state
                  : transport.state}
              </td>
              <td>{transport.destination_address}</td>
              <td>{transport.transport_length}</td>
              <td>
                <button
                  className="single-view"
                  onClick={() =>
                    props.history.push("/home/transportSingle", {
                      transportId: transport.transport_id,
                      userType: userType,
                      isFromFindTransport: false,
                    })
                  }
                >
                  View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ShowActiveTransports;
